export type ToastTone = 'prime' | 'twin' | 'famous' | 'accent' | 'neutral' | 'danger';

export interface Toast {
  id: number;
  title: string;
  body?: string;
  tone: ToastTone;
  /** Short glyph or number shown in the badge. */
  badge?: string;
}

const MAX_VISIBLE = 3;
const LIFETIME_MS = 2800;

class Toasts {
  items = $state<Toast[]>([]);
  #next = 1;
  #recent = new Map<string, number>();

  /** Shows a toast. `dedupeKey` suppresses repeats of the same message for a few seconds. */
  push(toast: Omit<Toast, 'id'>, dedupeKey?: string): void {
    const now = performance.now();
    if (dedupeKey) {
      const last = this.#recent.get(dedupeKey) ?? -Infinity;
      if (now - last < 4000) return;
      this.#recent.set(dedupeKey, now);
    }
    const item = { ...toast, id: this.#next++ };
    this.items = [...this.items, item].slice(-MAX_VISIBLE);
    setTimeout(() => this.dismiss(item.id), LIFETIME_MS);
  }

  dismiss(id: number): void {
    this.items = this.items.filter((t) => t.id !== id);
  }
}

export const toasts = new Toasts();
